import type { PolicyActionEnum } from '../actions.js';
import { allowStatement, POLICY_DOCUMENT_VERSION, type PolicyDocument } from '../document.js';

export type BuiltinPolicyKey = `builtin:${string}`;

export type BuiltinPolicyDefinition = {
  /** Stable identifier. Never change it once released; migrations and claim mappings rely on it. */
  key: BuiltinPolicyKey;
  name: string;
  description: string;
  document: PolicyDocument;
};

export function defineBuiltinPolicy(params: {
  key: BuiltinPolicyKey;
  name: string;
  description: string;
  actions: readonly PolicyActionEnum[];
}): BuiltinPolicyDefinition {
  return {
    key: params.key,
    name: params.name,
    description: params.description,
    document: {
      version: POLICY_DOCUMENT_VERSION,
      statements: [allowStatement([...params.actions])],
    },
  };
}

export type BuiltinRoleKey = `builtin:${string}`;

export type BuiltinRoleDefinition = {
  /** Stable identifier. Never change it once released; migrations rely on it. */
  key: BuiltinRoleKey;
  name: string;
  description: string;
  /**
   * The built-in policies the role bundles. Referencing the definitions (not keys) means a role
   * can't name a policy that doesn't exist. Built-in roles hold built-in policies only.
   */
  policies: readonly BuiltinPolicyDefinition[];
};

export function defineBuiltinRole(role: BuiltinRoleDefinition): BuiltinRoleDefinition {
  return role;
}
